// 自定义缴费
import Log from "../view/log";
import CustomPaymentNav from "../view/CustomPayment/CustomPaymentNav";
import ChargeItemsManagement from "../view/CustomPayment/ChargeItemsManagement/ChargeItemsManagement";
import ChargeItemsManagementAdd from "../view/CustomPayment/ChargeItemsManagement/ChargeItemsManagementAdd";
import ChargeItemsManagementModify from "../view/CustomPayment/ChargeItemsManagement/ChargeItemsManagementModify";
import ChargeManagement from "../view/CustomPayment/ChargeManagement/ChargeManagement";
import ChargeManagementAdd from "../view/CustomPayment/ChargeManagement/ChargeManagementAdd";
import RefundManagement from "../view/CustomPayment/RefundManagement/RefundManagement";
import RefundManagementAdd from "../view/CustomPayment/RefundManagement/RefundManagementAdd";
import RefundAddByCompany from "../view/CustomPayment/RefundManagement/RefundAddByCompany";
import RefundManagementConfirm from "../view/CustomPayment/RefundManagement/RefundManagementConfirm";

export default [
  /* 报名 */
  {
    path: "/charge_items_management",
    name: "charge-items-management",
    components: {
      default: CustomPaymentNav,
      a: ChargeItemsManagement
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/charge_items_management_add",
    name: "charge-items-management-add",
    components: {
      default: CustomPaymentNav,
      a: ChargeItemsManagementAdd
    }
  },
  {
    path: "/charge_items_management_modify/:id",
    name: "charge-items-management-modify",
    components: {
      default: CustomPaymentNav,
      a: ChargeItemsManagementModify
    }
  },
  {
    path: "/charge_management",
    name: "charge-management",
    components: {
      default: CustomPaymentNav,
      a: ChargeManagement
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/charge_management_add",
    name: "charge-management-add",
    components: {
      default: CustomPaymentNav,
      a: ChargeManagementAdd
    }
  },
  {
    path: "/refund_management",
    name: "refund-management",
    components: {
      default: CustomPaymentNav,
      a: RefundManagement
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/refund_management_add",
    name: "refund-management-add",
    components: {
      default: CustomPaymentNav,
      a: RefundManagementAdd
    }
  },
  {
    path: "/refund_add_by_company",
    name: "refund-add-by-company",
    components: {
      default: CustomPaymentNav,
      a: RefundAddByCompany
    }
  },
  {
    path: "/refund_management_confirm/:id",
    name: "refund-management-confirm",
    components: {
      default: CustomPaymentNav,
      a: RefundManagementConfirm
    }
  },
  {
    path: "/charge_log",
    name: "charge-log",
    components: {
      default: CustomPaymentNav,
      a: Log
    }
  }
];



// WEBPACK FOOTER //
// ./src/router/CustomPayment.js